import { Link } from "react-router-dom";
import { LOGO_URL, openIntake } from "@/lib/ebook";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-[#080808]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <img src={LOGO_URL} alt="Crowned Canvas Creations — official logo" className="h-28 w-auto object-contain" />
            </Link>
            <p className="overline mt-5">Crowned Canvas Creations LLC</p>
            <p className="text-[#F7F1E7]/55 text-sm mt-3 max-w-sm font-light leading-relaxed">
              Where your story becomes a masterpiece. Custom portrait &amp; canvas
              artwork studio based in Madison, Wisconsin — serving clients
              online wherever they are.
            </p>
            <button
              type="button"
              onClick={() => openIntake("footer")}
              data-testid="footer-intake"
              className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] border border-[#D4AF37]/40 text-[#D4AF37] px-5 py-3 hover:bg-[#D4AF37] hover:text-black transition-all"
            >
              Start Your Crowned Intake →
            </button>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5">Explore</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/collection/royal-essence" className="hover:text-[#D4AF37]">Royal Essence</Link></li>
              <li><Link to="/collection/sovereign" className="hover:text-[#D4AF37]">Sovereign Canvas</Link></li>
              <li><Link to="/collection/majestic-vibes" className="hover:text-[#D4AF37]">Majestic Vibes</Link></li>
              <li><Link to="/how-it-works" className="hover:text-[#D4AF37]">How It Works</Link></li>
              <li><Link to="/ebook" className="hover:text-[#D4AF37]">Free Photo Guide</Link></li>
              <li><Link to="/black-excellence-unveiled" className="hover:text-[#D4AF37]">Black Excellence Unveiled</Link></li>
              <li><Link to="/legacy-members" className="hover:text-[#D4AF37]">Legacy Members</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="overline mb-5">Policies</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/legal/privacy" className="hover:text-[#D4AF37]">Privacy Policy</Link></li>
              <li><Link to="/legal/terms" className="hover:text-[#D4AF37]">Terms &amp; Conditions</Link></li>
              <li><Link to="/legal/refund" className="hover:text-[#D4AF37]">Refund &amp; Cancellation</Link></li>
              <li><Link to="/legal/shipping" className="hover:text-[#D4AF37]">Shipping Policy</Link></li>
              <li><Link to="/legal/revisions" className="hover:text-[#D4AF37]">Revision Policy</Link></li>
              <li><Link to="/legal/accessibility" className="hover:text-[#D4AF37]">Accessibility</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-3">
          <p className="text-xs text-white/40 tracking-wide">
            © 2026 Crowned Canvas Creations LLC. All Rights Reserved.
          </p>
          <p className="text-xs text-white/40 tracking-wide italic font-serif-display">
            &ldquo;You give us the story. We crown the moment.&rdquo;
          </p>
        </div>
      </div>
    </footer>
  );
}
